import http from '@/common/api/http';

const baseUrl = "/newJava";

//配置信息
export const receiveCarCouponConf = (params) => {
    return http.get(`html5/activity/V1/receiveCarCouponConf`, {params});
};


//领券
export const receiveCarCoupon = (data) => {
    return http.post(`/html5/activity/V1/receiveCarCoupon`, data);
};

